<section>
  <app-form-header></app-form-header>
  <app-information-block [text]="'LETTING.ADVERTISMENT.HOMEQ.MULTIPLE_OFFICES_INFO' | translate"></app-information-block>
  <form>
    @for (group of groupedDwellings | keyvalue; track group) {
      <div>
        <div class="property-header row col-12">
          <h5>{{ group.key }}</h5>
          @if (homeQOffices && homeQOffices.length) {
            <div class="col-md-4 col-6">
              @if (displayStates[group.key]) {
                <app-text-box-readonly
                  [caption]="'PROPERTY.HOMEQ_OFFICE'"
                  [text]="form.get(group.key).value"
                ></app-text-box-readonly>
              } @else {
                <app-autocomplete [control]="form.get(group.key)" [itemsSource]="homeQOffices"></app-autocomplete>
              }
            </div>
          }
        </div>
        <div class="row form-group">
          <div class="col-12">
            <app-accordion [header]="'DASHBOARD.MENU.DWELLING'">
              <div class="col-12">
                <app-list-view
                  [columnDefinition]="dwellingColumnDefinition"
                  [itemsSource]="group.value"
                  [preferencesKey]="'rent.send-to-homeq.dwellings'"
                ></app-list-view>
              </div>
            </app-accordion>
          </div>
        </div>
      </div>
    }
    <div class="row form-group">
      @if (form) {
        <div class="col-12">
          <button class="btn btn-primary" (click)="onSubmit()" [disabled]="disableSubmit">{{ 'COMMON.SEND' | translate }}</button>
          <button class="btn link-btn ml-2" (click)="onCancel()">{{ 'CANCEL_BTN' | translate }}</button>
        </div>
      }
    </div>
  </form>
</section>
